import { ApolloCache, useApolloClient } from "@apollo/client";
import { useCallback } from "react";

type RootQueryType = Record<string, unknown>;

export const usePaymentSuccessUpdateFn = () => {
  const client = useApolloClient();
  const updateFn = useCallback(() => {
    const cacheData = (
      client.cache as ApolloCache<{
        ROOT_QUERY: RootQueryType;
      }>
    ).extract();
    const rootQuery = cacheData.ROOT_QUERY;

    Object.keys(rootQuery).forEach((key) => {
      if (key.match(/post\(/)) {
        client.cache.evict({ id: "ROOT_QUERY", fieldName: key });
        client.cache.gc();
      }
    });

    client.refetchQueries({
      include: ["subscriptionPlanPage"],
    });
  }, [client]);

  return updateFn;
};
